/**
 * Helper typescript function useful to ensure that if value is not null or undefined, it is of type T
 */
export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
